import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { firebase as fb, helpers } from 'redux-firebasev3';
import includes from 'lodash/includes';

import ChannelList from '../ChannelList';
import Page from '../Page';
import Loading from '../../components/Loading';
import ErrorPage from '../../components/ErrorPage';
import AddToSlackButton from '../../components/AddToSlackButton';
import teamIdFromAuth from '../../enhancers/teamIdFromAuth';
import { teamMetaPath, teamSlackPath } from '../../utils/firebasePaths';

const { dataToJS, isLoaded } = helpers;

@teamIdFromAuth()
@fb(({ teamId }) => [
  `${teamMetaPath(teamId)}/client`,
  `${teamMetaPath(teamId)}/name`,
  `${teamSlackPath(teamId)}/scope`,
])
@connect(
  ({ firebase }, { teamId }) => ({
    client: dataToJS(firebase, `${teamMetaPath(teamId)}/client`),
    name: dataToJS(firebase, `${teamMetaPath(teamId)}/name`),
    scope: dataToJS(firebase, `${teamSlackPath(teamId)}/scope`),
  })
)
export default class Team extends Component {
  static propTypes = {
    children: PropTypes.node,
    client: PropTypes.string,
    name: PropTypes.string,
    scope: PropTypes.string,
    teamId: PropTypes.string.isRequired,
  }

  render() {
    const {
      client,
      name,
      scope,
      teamId,
    } = this.props;

    if (!isLoaded(client, name, scope)) {
      return <Loading />;
    }

    const scopes = (scope || '').split(',');
    const couldBeSlack = !client || client === 'slack';

    if (couldBeSlack && !includes(scopes, 'commands')) {
      if (Raven) {
        Raven.captureMessage('Not added to slack error', {
          extra: { teamId }
        });
      }

      return (
        <ErrorPage
          pageTitle="Not Added to Slack"
          subtitle="Add SOTU to Slack to start using it in your team."
          title="Oops! SOTU has not yet been added to your team."
        >
          <AddToSlackButton className="mv4" />
        </ErrorPage>
      );
    }

    return (
      <Page pageTitle={name}>
        <div>
          <ChannelList client={client} teamId={teamId} />
        </div>
      </Page>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/Team/index.jsx
 **/